"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _Intl = _interopRequireDefault(require("../../proptypes/Intl"));
var _Box = _interopRequireDefault(require("../../Box"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _ExpandNavigationItemIcon = _interopRequireDefault(require("./ExpandNavigationItemIcon"));
var _NavigationItemIcon = _interopRequireDefault(require("./NavigationItemIcon"));
var _NavigationItemWrapper = _interopRequireDefault(require("./NavigationItemWrapper"));
var _NavigationItemBadge = require("./NavigationItemBadge");
var _excluded = ["ariaControls", "className", "component", "text", "icon", "isSelected", "isSubsectionOpened", "hasSubsection", "onClick", "typographyProps", "badgeCount", "badgeVariant", "staticBadge"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var NavigationItem = function NavigationItem(_ref) {
  var ariaControls = _ref.ariaControls,
    className = _ref.className,
    component = _ref.component,
    text = _ref.text,
    icon = _ref.icon,
    isSelected = _ref.isSelected,
    isSubsectionOpened = _ref.isSubsectionOpened,
    hasSubsection = _ref.hasSubsection,
    onClick = _ref.onClick,
    typographyProps = _ref.typographyProps,
    badgeCount = _ref.badgeCount,
    badgeVariant = _ref.badgeVariant,
    staticBadge = _ref.staticBadge,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_NavigationItemWrapper["default"], _extends({
    "aria-controls": ariaControls,
    className: className,
    component: component,
    hasSubsection: hasSubsection,
    isSubsectionOpened: isSubsectionOpened,
    selected: isSelected,
    onClick: onClick,
    disableRipple: true
  }, props), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    alignItems: "center"
  }, icon && /*#__PURE__*/_react["default"].createElement(_NavigationItemIcon["default"], {
    icon: icon
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], _extends({}, typographyProps, {
    kind: isSelected ? 'interaction' : 'default'
  }), typeof text === 'string' ? text : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, text)), hasSubsection && /*#__PURE__*/_react["default"].createElement(_ExpandNavigationItemIcon["default"], {
    isExpanded: isSubsectionOpened
  }), badgeCount > 0 && /*#__PURE__*/_react["default"].createElement(_NavigationItemBadge.NavigationItemBadge, {
    variant: badgeVariant,
    count: badgeCount
  }), staticBadge && badgeCount === 0 && /*#__PURE__*/_react["default"].createElement(_NavigationItemBadge.NavigationItemBadge, {
    variant: badgeVariant
  })));
};
NavigationItem.propTypes = process.env.NODE_ENV !== "production" ? {
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _Intl["default"]]).isRequired,
  ariaControls: _propTypes["default"].string,
  className: _propTypes["default"].string,
  component: _propTypes["default"].elementType,
  hasSubsection: _propTypes["default"].bool,
  icon: _propTypes["default"].elementType,
  isSelected: _propTypes["default"].bool,
  isSubsectionOpened: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  typographyProps: _propTypes["default"].object,
  badgeCount: _propTypes["default"].number,
  badgeVariant: _propTypes["default"].string,
  staticBadge: _propTypes["default"].bool
} : {};
NavigationItem.defaultProps = {
  component: 'li',
  isSelected: false,
  typographyProps: {
    mr: 1,
    color: 'textPrimary'
  },
  badgeCount: 0,
  staticBadge: false,
  badgeVariant: 'default'
};
var _default = exports["default"] = NavigationItem;